if (!customElements.get("product-medias-popup")) {
	customElements.define(
		"product-medias-popup",
		class ProductMediasPopup extends HTMLElement {
			connectedCallback() {
				this.popups = this.querySelectorAll(".product-media-popup");
				if (this.popups) this.init();
			}

			init() {
				this.popups.forEach((popup) => {
					if (popup.dataset.mounted === "1") return;

					const targetPosition = popup.dataset.targetPosition;
					if (!targetPosition) return;

					const container = document.getElementById(
						popup.dataset.targetContainer
					);
					if (!container) return;

					const target = container.querySelector(
						`[data-media-position="${targetPosition}"]`
					);
					if (!target) {
						popup.remove();
						return;
					}

					target.appendChild(popup);
					popup.dataset.mounted = "1";
				});
			}

			reset() {
				this.popups.forEach((popup) => (popup.dataset.mounted = "0"));
				this.init();
			}
		}
	);
}
